const STATIC_DATA = {
  otherObj: {
    areaId: 3,
    areaIdd: "0003",
    areaName: "福建",
    areaOther: [
      { areaid: 1, name: "安徽省" },
      { areaid: 2, name: "北京市" },
      { areaid: 3, name: "福建省" },
      { areaid: 4, name: "甘肃省" },
      { areaid: 5, name: "广东省" },
      { areaid: 6, name: "广西省" },
      { areaid: 7, name: "贵州省" },
      { areaid: 8, name: "海南省" },
      { areaid: 9, name: "河北省" },
      { areaid: 10, name: "河南省" },
      { areaid: 11, name: "黑龙江省" },
      { areaid: 12, name: "湖北省" },
      { areaid: 13, name: "湖南省" },
      { areaid: 14, name: "吉林省" },
      { areaid: 15, name: "江苏省" },
      { areaid: 16, name: "江西省" },
      { areaid: 17, name: "辽宁省" },
      { areaid: 18, name: "内蒙古" },
      { areaid: 19, name: "宁夏省" },
      { areaid: 20, name: "青海省" },
      { areaid: 21, name: "山东省" },
      { areaid: 22, name: "山西省" },
      { areaid: 23, name: "陕西省" },
      { areaid: 24, name: "上海市" },
      { areaid: 25, name: "四川省" },
      { areaid: 26, name: "天津市" },
      { areaid: 27, name: "西藏" },
      { areaid: 28, name: "新疆" },
      { areaid: 29, name: "云南省" },
      { areaid: 30, name: "浙江省" },
      { areaid: 31, name: "重庆市" },
    ],
    friendLinks: [],
    guessYouLike: [
      { name: "工程网", id: 392 },
      { name: "土石方工程网", id: 393 },
      { name: "中国园林工程网", id: 394 },
      { name: "载人航天工程网", id: 395 },
      { name: "绿化工程网", id: 396 },
      { name: "污水工程网", id: 397 },
      { name: "音视频工程网", id: 398 },
      { name: "建筑教育工程网", id: 399 },
      { name: "承包工程网", id: 400 },
      { name: "高速工程网", id: 401 },
      { name: "水利建设工程网", id: 402 },
      { name: "工程招标投标网", id: 403 },
      { name: "水利招标投标网", id: 404 },
      { name: "给排水工程招标", id: 405 },
      { name: "科学技术厅", id: 407 },
      { name: "环境保护厅", id: 408 },
      { name: "民政厅", id: 409 },
      { name: "审计厅", id: 410 },
      { name: "住房城乡建设厅", id: 411 },
      { name: "国土资源厅", id: 412 },
    ],
    keynum: 71,
    keyword: "搅拌站",
    nationalGuessYouLike: [
      { name: "水接头", id: 2124 },
      { name: "软齿轮", id: 2178 },
      { name: "锅炉节煤设备", id: 7843 },
      { name: "士兵服装", id: 35404 },
      { name: "科勒卫浴马桶", id: 39526 },
      { name: "彩涂镀锌钢板", id: 42414 },
      { name: "酒类防伪标识", id: 94541 },
      { name: "酸洗钝化", id: 99886 },
      { name: "纯银吊坠扣配件", id: 101174 },
      { name: "特宽印花", id: 103527 },
      { name: "塑料压铸产品", id: 110275 },
      { name: "永一塑胶模具", id: 125732 },
      { name: "测高仪", id: 150644 },
      { name: "固态高频焊接", id: 178316 },
      { name: "三基色荧光灯", id: 185755 },
      { name: "消防水龙头", id: 189206 },
      { name: "恒联绞肉机", id: 238998 },
      { name: "减速机变速箱", id: 250202 },
      { name: "拆焊台系列", id: 260284 },
      { name: "太阳能光伏电池板", id: 274720 },
    ],
    nowUrl: "website-seo/v2/gjxx/otherData/71/3/-1/1",
    purchasingAgency: [
      { name: "东莞市宏霖五金橡胶制有限公司", id: 38026908 },
      { name: "青岛锐城智能设备有限公司", id: 38026907 },
      { name: "青岛德音化工有限公司", id: 38026906 },
      { name: "青岛乾泓盛机械有限公司", id: 38026905 },
      { name: "青岛绿荣园艺景观有限公司", id: 38026904 },
      { name: "青岛金庄天缘国际贸易有限公司", id: 38026903 },
      { name: "青岛博鑫七彩贝壳新型建材有限公司", id: 38026902 },
      { name: "青岛鸿鑫宇有限公司", id: 38026901 },
      { name: "青岛万仕和有限公司", id: 38026900 },
      { name: "青岛好富得包装有限公司", id: 38026899 },
    ],
    ssx: "sheng",
    title: "福建搅拌站招标采购",
    typesId: "4",
    typesName: "",
    wId: 71,
  },
  listObj: {
    areaName: "福建",
    bodyData: [
      {
        areaName: "福州市",
        areaid: 141,
        content:
          "...任期24个月。计划开工时间2022年8月，计划交工时间2023年4月。 施工任务包括混凝土<a style='color:red;'>搅拌站</a>联合厂房（含变配电室）、卸料车间、地源热泵房、消防水池及泵房、公共卫生间、警卫室及室外工程等。 2.报价内容 询价采购编号：FA*** 报价内容：中交第二公路工程局有限公司荣乌高速新线智能建造中心项目总承包项目经理部砖物资采购询价 使用地点：河北省...( <span style='color: #EA0A00'>搅拌站</span> 在正文中 )",
        contentid: 419924647,
        inputtime: "2024-05-13",
        keyworDescribe: "关键描述:",
        progid: 0,
        progstr: "招标公告",
        searchType: 1,
        title: "中交第二公路工程局有限公司荣乌高速新线智能建造中心项目总承包项目经理部砖物资采购询价公告",
        typeid: 49,
        url: "https://www.qianlima.com/bid-419924647.html",
      },
      {
        areaName: "福州市",
        areaid: 141,
        content:
          "延时控制器 台 3 智能电源控制器 16 擦机抹布 平方米 300 棉布 擦拭布 17 电镐 台 3 电镐 18 电磁阀 9140 只 5 混凝土<a style='color:red;'>搅拌站</a>电磁阀 电磁阀 SY9140 19 开关电源 15KW 套 5 组合开关电源 20 压扣钢索具 D28*6米 个 4 末端卸扣 21 松香水 公斤 200 松香水 22 不锈钢护栏( <span style='color: #EA0A00'>搅拌站</span> 在正文中 )",
        contentid: 419897482,
        inputtime: "2024-05-13",
        keyworDescribe: "关键描述:",
        progid: 0,
        progstr: "招标公告",
        searchType: 1,
        title: "中交二航局张靖皋节段梁项目零星采购询价",
        typeid: 45,
        url: "https://www.qianlima.com/bid-419897482.html",
      },
      {
        areaName: "宁德市",
        areaid: 168,
        content:
          "...13 16:00:00 宁德二期、宁德备品备件仓库、廉江一期、太平岭一期BOH项目、BLG<a style='color:red;'>搅拌站</a>项目塔式起重机及田湾7、8号机组施工升降机安拆、运行、维保成交候选人公示 1、 项目基本信息 项目名称：宁德二期、宁德备品备件仓库、廉江一期、太平岭一期BOH项目、BLG<a style='color:red;'>搅拌站</a>项目塔式起重机及田湾7、8号机组施工升降机安拆、运行、维保 项目编号：HXJS-GC-G...( <span style='color: #EA0A00'>搅拌站</span> 在正文中 )",
        contentid: 419854612,
        inputtime: "2024-05-13",
        keyworDescribe: "关键描述:",
        progid: 3,
        progstr: "中标结果",
        searchType: 1,
        title: "宁德二期、廉江一期等项目塔式起重机及施工升降机安拆、运行、维保成交候选人公示",
        typeid: 58,
        url: "https://www.qianlima.com/bid-419854612.html",
      },
      {
        areaName: "福州市",
        areaid: 141,
        content:
          "...五公司两座混凝土<a style='color:red;'>搅拌站</a>出售询价通知 项目编号：SCFA*** 发布时间：2024-05-12 17:19:00 公告 公告标题：五公司两座混凝土<a style='color:red;'>搅拌站</a>出售询价通知 公告内容： 询 价 书 两座混凝土拌合站出售询价书 1. 询价条件 本招标项目为中交一航局第五工程有限公司自有的一座HZS180混凝土拌合站和一座HES120混凝土拌合站二手买卖项...( <span style='color: #EA0A00'>搅拌站</span> 在正文中 )",
        contentid: 419678107,
        inputtime: "2024-05-12",
        keyworDescribe: "关键描述:",
        progid: 0,
        progstr: "招标公告",
        searchType: 1,
        title: "五公司两座混凝土<span style='color: #EA0A00'> 搅拌站</span>出售询价通知",
        typeid: 46,
        url: "https://www.qianlima.com/bid-419678107.html",
      },
      {
        areaName: "福州市",
        areaid: 141,
        content:
          "...电动 单级离心清水泵 100-150mm 电动 100.00000000 台 5 混凝土<a style='color:red;'>搅拌站</a>振动器 混凝土<a style='color:red;'>搅拌站</a>振动器 - 2m 2.00000000 套 6 混凝土<a style='color:red;'>搅拌站</a>振动器 混凝土<a style='color:red;'>搅拌站</a>振动器 - 骨料仓振动器 MVE100/3N10A0 2.00000000 套 7 混凝土<a style='color:red;'>搅拌站</a>振动器 混凝土<a style='color:red;'>搅拌站</a>振动器 - 气动振动器 K10...( <span style='color: #EA0A00'>搅拌站</span> 在正文中 )",
        contentid: 419662300,
        inputtime: "2024-05-12",
        keyworDescribe: "关键描述:",
        progid: 0,
        progstr: "招标公告",
        searchType: 1,
        title: "宁古高速C2标零星材料6询价公告",
        typeid: 49,
        url: "https://www.qianlima.com/bid-419662300.html",
      },
      {
        areaName: "福州市",
        areaid: 141,
        content:
          "游标卡尺 游标卡尺 - 0-300mm 1.00000000 个 38 货架 货架 - 长2000*高2000*进深500 10.00000000 套 39 票据打印机 票据打印机 - <a style='color:red;'>搅拌站</a>用打印机 2.00000000 台( <span style='color: #EA0A00'>搅拌站</span> 在正文中 )",
        contentid: 419661982,
        inputtime: "2024-05-12",
        keyworDescribe: "关键描述:",
        progid: 0,
        progstr: "招标公告",
        searchType: 1,
        title: "宁古高速C2标零星材料5询价公告",
        typeid: 49,
        url: "https://www.qianlima.com/bid-419661982.html",
      },
      {
        areaName: "泰宁县",
        areaid: 193,
        content:
          "...定资格要求： 采购包1： 明细 描述 供应商须具备沥青混合料生产能力的生产企业 须提供生产<a style='color:red;'>搅拌站</a>营业执照及生产企业现场图片并加盖投标人公章。 三、获取招标文件 时间： 2024-05-11 至 2024-05-17 ，（提供期限自本公告发布之日起不得少于5个工作日），每天上午08:00:00至12:00:00，下午14:30:00至17:30:00（北京时间...( <span style='color: #EA0A00'>搅拌站</span> 在正文中 )",
        contentid: 419657216,
        inputtime: "2024-05-12",
        keyworDescribe: "关键描述:",
        progid: 0,
        progstr: "招标公告",
        searchType: 1,
        title: "泰宁县邵武交界至朱口音山水毁公路重建项目（二期）沥青混合料及运输服务采购项目",
        typeid: 45,
        url: "https://www.qianlima.com/bid-419657216.html",
      },
      {
        areaName: "福州市",
        areaid: 141,
        content:
          "...隧道局2024年5月<a style='color:red;'>搅拌站</a>租赁询价 项目编号：SCFA*** 发布时间：2024-05-11 10:41:00 公告 公告标题：隧道局2024年5月<a style='color:red;'>搅拌站</a>租赁询价 公告内容： 询价邀请函 采购编号：ZJYGJ-SDJ-2024035 1.采购条件 中交隧道工程局有限公司广州地铁十二号线项目<a style='color:red;'>搅拌站</a>租赁具备询价采购条件，现进行询价采购。 2.项目...( <span style='color: #EA0A00'>搅拌站</span> 在正文中 )",
        contentid: 419474227,
        inputtime: "2024-05-11",
        keyworDescribe: "关键描述:",
        progid: 0,
        progstr: "招标公告",
        searchType: 1,
        title: "隧道局2024年5月<span style='color: #EA0A00'> 搅拌站</span>租赁询价",
        typeid: 61,
        url: "https://www.qianlima.com/bid-419474227.html",
      },
      {
        areaName: "福州市",
        areaid: 141,
        content:
          "...二）交货周期：项目完工结束前陆续交付完毕； （三）交付地点：瑞安市中交二航局甬台温复线项目<a style='color:red;'>搅拌站</a>。 （四）双方办理完结算手续、卖方提供符合合同要求的正式发票给买方，扣除3%质保金后，剩余结算金额60天内支付。支付方式：以银行转账或银行承兑汇票、供应链等方式支付，贴息费用由买方承担。特殊情况因项目资金紧张付款滞后等非我司原因造成支付困难、资金不到位，我司的货款...( <span style='color: #EA0A00'>搅拌站</span> 在正文中 )",
        contentid: 419623554,
        inputtime: "2024-05-11",
        keyworDescribe: "关键描述:",
        progid: 0,
        progstr: "招标公告",
        searchType: 1,
        title: "中交华东物资有限公司水泥公开询价采购公告",
        typeid: 49,
        url: "https://www.qianlima.com/bid-419623554.html",
      },
      {
        areaName: "福州市",
        areaid: 141,
        content:
          "...0MPa 1×7(0.6mm) 钢丝绳粗20长6m 2.00000000 吨 20 混凝土<a style='color:red;'>搅拌站</a>滚筒 电动滚筒11千瓦（950*500）型号TDY75型 1.00000000 个 21 钢构 锁紧挡块175*65 25.00000000 套 22 混凝土<a style='color:red;'>搅拌站</a>托辊 托辊1150*108...( <span style='color: #EA0A00'>搅拌站</span> 在正文中 )",
        contentid: 419610413,
        inputtime: "2024-05-11",
        keyworDescribe: "关键描述:",
        progid: 0,
        progstr: "招标公告",
        searchType: 1,
        title: "轧石场、拌合站配件",
        typeid: 46,
        url: "https://www.qianlima.com/bid-419610413.html",
      },
      {
        areaName: "漳州市",
        areaid: 205,
        content:
          "...第三条生产线封闭工程—钢结构施工（三次） 二、项目地点：漳州市高新区九湖镇林下村龙成混凝土<a style='color:red;'>搅拌站</a>站内 三、比选范围：第三条生产线封闭工程 四、比选内容：参选人施工的内容包含：预埋铁件、螺栓；实腹钢柱、柱间支撑、钢梁、钢支撑、钢拉条、钢檩条制作安装；型材屋面（屋面彩钢板）安装、钢板墙板安装、屋面天沟、檐沟防水安装、墙面装饰板安装及完成本项目所需的各项安全文明措...( <span style='color: #EA0A00'>搅拌站</span> 在正文中 )",
        contentid: 419596103,
        inputtime: "2024-05-11",
        keyworDescribe: "关键描述:",
        progid: 0,
        progstr: "招标公告",
        searchType: 1,
        title: "第三条生产线封闭工程—钢结构施工（三次）比选公告",
        typeid: 61,
        url: "https://www.qianlima.com/bid-419596103.html",
      },
      {
        areaName: "福州市",
        areaid: 141,
        content:
          "...30度~+50度；SAP询价单：1000018099 2.00000000 件 2 混凝土<a style='color:red;'>搅拌站</a>密封胶条 物资名称：密封胶条 MFT-002 三元乙丙橡胶；采购要求：l=16m部件名称RS正面吊24-045联系单(流机)(第一次发图完)；SAP询价单：1000018099；表面处理：NA 1.00000000 件 3 塑料保护套管 物资名称：双面护套 14...( <span style='color: #EA0A00'>搅拌站</span> 在正文中 )",
        contentid: 419531815,
        inputtime: "2024-05-11",
        keyworDescribe: "关键描述:",
        progid: 0,
        progstr: "招标公告",
        searchType: 1,
        title: "五金采购",
        typeid: 49,
        url: "https://www.qianlima.com/bid-419531815.html",
      },
      {
        areaName: "福州市",
        areaid: 141,
        content:
          "...化工园湛水路700号中交三航局三公司第一工程处 、扬州市仪征市铜山区枣林湾站前路中交三航<a style='color:red;'>搅拌站</a>。 3、 质量要求：参考国标。 4、 计价方式：固定价格。 5、 付款方式：供货结束后，开增值税专用发票，60日内全额付款。 6、 供货方式：汽运或快递一次性供应。 7、 如有材料疑问请联系人： 马万春联系电话：*** （现场）。 8、 收货人联系...( <span style='color: #EA0A00'>搅拌站</span> 在正文中 )",
        contentid: 419524524,
        inputtime: "2024-05-11",
        keyworDescribe: "关键描述:",
        progid: 0,
        progstr: "招标公告",
        searchType: 1,
        title: "中交三航局三公司集采中心采购第一工程处-轮胎等",
        typeid: 45,
        url: "https://www.qianlima.com/bid-419524524.html",
      },
      {
        areaName: "福州市",
        areaid: 141,
        content:
          "...辆车长期驻场（具体以甲方通知为准），运输车辆应为混凝土运输专用罐车，运输路线：1.甲方自有<a style='color:red;'>搅拌站</a>至甲方生产线；2.甲方指定商混站至甲方生产线。报价人应进行现场踏勘。 2.3 计划工期：2024年5月至2025年4月 3.供应商资格要求 3.1 供应商资格条件要求： （1）营业范围要求：具有独立法人资格，且具有合法、有效的“三证合一”的营业执照。 （2）资质条...( <span style='color: #EA0A00'>搅拌站</span> 在正文中 )",
        contentid: 419427226,
        inputtime: "2024-05-11",
        keyworDescribe: "关键描述:",
        progid: 0,
        progstr: "招标公告",
        searchType: 1,
        title: "中交浚浦建筑科技（上海）有限公司建筑工业化总厂横沙基地混凝土运输询价采购公告",
        typeid: 45,
        url: "https://www.qianlima.com/bid-419427226.html",
      },
      {
        areaName: "福州市",
        areaid: 141,
        content:
          "15 PLC控制柜 PLC 西门子 st20 5.00000000 套 16 高温水源热泵 蒸汽发生器上水泵 0.55kw 16.00000000 台 17 混凝土<a style='color:red;'>搅拌站</a>传动链条 链条 20A 5.00000000 条 18 电动机 走行电机 1.5kw 5.00000000 台 19 电动推杆 密封电液推杆 S400mm( <span style='color: #EA0A00'>搅拌站</span> 在正文中 )",
        contentid: 419423408,
        inputtime: "2024-05-11",
        keyworDescribe: "关键描述:",
        progid: 3,
        progstr: "中标结果",
        searchType: 1,
        title: "川藏5标二分部蒸养台车配件公开单一来源采购公告",
        typeid: 49,
        url: "https://www.qianlima.com/bid-419423408.html",
      },
      {
        areaName: "福鼎市",
        areaid: 166,
        content:
          "...中国核工业二四建设有限公司 -宁德核电项目部5、6号<a style='color:red;'>搅拌站</a>设备采购计划-竞争性谈判采购公告 一、项目概况 项目名称：宁德核电项目部5、6号<a style='color:red;'>搅拌站</a>设备采购计划 项目编号：24EC-WZ-GKJT-24-0571 交货/服务时间：供货期限：自合同签订生效之日起至履约完毕为止。 交货/服务地点：福建省宁德市福鼎市太姥山镇核电现场 供货范围：采购范围：本次采购内容为...( <span style='color: #EA0A00'>搅拌站</span> 在正文中 )",
        contentid: 419137604,
        inputtime: "2024-05-10",
        keyworDescribe: "关键描述:",
        progid: 0,
        progstr: "招标公告",
        searchType: 1,
        title: "宁德核电项目部5、6号<span style='color: #EA0A00'> 搅拌站</span>设备采购计划采购公告",
        typeid: 46,
        url: "https://www.qianlima.com/bid-419137604.html",
      },
      {
        areaName: "福州市",
        areaid: 141,
        content:
          "ol 1 限位器 重锤限位器 10.00000000 个 2 船用变速箱 5.00000000 个 3 混凝土<a style='color:red;'>搅拌站</a>高强螺栓 50.00000000 个 4 定滑轮 吊线滑轮 20.00000000 个 5 钢轨压板 GDGL-1 焊接压板 900.( <span style='color: #EA0A00'>搅拌站</span> 在正文中 )",
        contentid: 419159521,
        inputtime: "2024-05-10",
        keyworDescribe: "关键描述:",
        progid: 0,
        progstr: "招标公告",
        searchType: 1,
        title: "四公司青海乐化项目机械配件公开询价采购",
        typeid: 49,
        url: "https://www.qianlima.com/bid-419159521.html",
      },
      {
        areaName: "永定县",
        areaid: 153,
        content:
          "...【采购结果公示】2024年度宏鼎<a style='color:red;'>搅拌站</a>碎石原材料采购项目（三次）结果公告 2024年度宏鼎<a style='color:red;'>搅拌站</a>碎石原材料采购项目（三次） 结果公告 1、项目名称： 2024年度宏鼎<a style='color:red;'>搅拌站</a>碎石原材料采购项目（三次） 2、项目编号： FJZH[2024]-CG014-2号 3、采购人名称： 福建客家宏翔贸易有限公司 地址： 龙岩市永定区凤城街道 项目负责人： 游先生 联系电话...( <span style='color: #EA0A00'>搅拌站</span> 在正文中 )",
        contentid: 419058334,
        inputtime: "2024-05-09",
        keyworDescribe: "关键描述:",
        progid: 3,
        progstr: "中标结果",
        searchType: 1,
        title:
          "【采购结果公示】2024年度宏鼎<span style='color: #EA0A00'> 搅拌站</span>碎石原材料采购项目（三次）结果公告",
        typeid: 68,
        url: "https://www.qianlima.com/bid-419058334.html",
      },
      {
        areaName: "永定县",
        areaid: 153,
        content:
          "...公示】龙岩市永定区宏鼎混凝土有限公司采购机制砂原材料项目（三次）结果公告 2024年度宏鼎<a style='color:red;'>搅拌站</a>机制砂原材料采购项目（三次） 结果公告 1、项目名称： 2024年度宏鼎<a style='color:red;'>搅拌站</a>机制砂原材料采购项目（三次） 2、项目编号： FJZH[2024]-CG015-2号 3、采购人名称： 福建客家宏翔贸易有限公司 地址： 龙岩市永定区凤城街道 项目负责人： 游先生 联系...( <span style='color: #EA0A00'>搅拌站</span> 在正文中 )",
        contentid: 419057641,
        inputtime: "2024-05-09",
        keyworDescribe: "关键描述:",
        progid: 3,
        progstr: "中标结果",
        searchType: 1,
        title: "【采购结果公示】龙岩市永定区宏鼎混凝土有限公司采购机制砂原材料项目（三次）结果公告",
        typeid: 49,
        url: "https://www.qianlima.com/bid-419057641.html",
      },
      {
        areaName: "金门县",
        areaid: 179,
        content:
          "5 工业酒精 优等品 工业酒精 优等品 500ml、每瓶 2.00000000 吨 6 醇基燃料 醇基燃料 2.00000000 千克 7 混凝土<a style='color:red;'>搅拌站</a>蝶阀 混凝土<a style='color:red;'>搅拌站</a>蝶阀 - DN50 3.00000000 个 8 空压机 通用类别 空压机 通用类别 1.00000000 台 9 数字万用表 数字万用表( <span style='color: #EA0A00'>搅拌站</span> 在正文中 )",
        contentid: 419019780,
        inputtime: "2024-05-09",
        keyworDescribe: "关键描述:",
        progid: 0,
        progstr: "招标公告",
        searchType: 1,
        title: "宁古C2零星材料4询价公告",
        typeid: 49,
        url: "https://www.qianlima.com/bid-419019780.html",
      },
      {
        areaName: "福州市",
        areaid: 141,
        content:
          "l 1 小齿轮 小齿轮 - 减速机 1.00000000 件 2 左搅拌臂 左搅拌臂 1.00000000 套 3 混凝土<a style='color:red;'>搅拌站</a>叶片 混凝土<a style='color:red;'>搅拌站</a>叶片 7.00000000 片 4 混凝土<a style='color:red;'>搅拌站</a>开关 混凝土<a style='color:red;'>搅拌站</a>开关 - 行程开关XCKP21026-11 2.00000000 个 5 混凝土<a style='color:red;'>搅拌站</a>开关 混凝土<a style='color:red;'>搅拌站</a>开关( <span style='color: #EA0A00'>搅拌站</span> 在正文中 )",
        contentid: 418977354,
        inputtime: "2024-05-09",
        keyworDescribe: "关键描述:",
        progid: 0,
        progstr: "招标公告",
        searchType: 1,
        title: "二航局六分公司国道338项目零星材料询价采购询价公告",
        typeid: 49,
        url: "https://www.qianlima.com/bid-418977354.html",
      },
      {
        areaName: "漳州市",
        areaid: 205,
        content:
          "...供方须保持完整的生产记录、原材料出厂合格证、进场检验等资料，随时接受监理工程师和需方代表对<a style='color:red;'>搅拌站</a>的现场检查（包括对原材料的抽检和生产过程 的监控及抽检，并检查其内业资料是否与产品相对应），供方对此要积极配合，不得以任何理由和借口进行推辞。 质量保证期：本合同项下货物的质量保证期为12个月。自批次供货验收合格并办理结算之日起进入质保期。 2、质保期要求： 2....( <span style='color: #EA0A00'>搅拌站</span> 在正文中 )",
        contentid: 418918612,
        inputtime: "2024-05-09",
        keyworDescribe: "关键描述:",
        progid: 0,
        progstr: "招标公告",
        searchType: 1,
        title: "【物资类】中国电建港航公司水电分公司漳州绿色发展生态治理项目透水沥青混凝土采购项目询价公告",
        typeid: 49,
        url: "https://www.qianlima.com/bid-418918612.html",
      },
      {
        areaName: "福州市",
        areaid: 141,
        content:
          "序号 设备物资名称 设备物资说明 数量 单位 1 沥青<a style='color:red;'>搅拌站</a>辅助设备 1.00000000 台( <span style='color: #EA0A00'>搅拌站</span> 在正文中 )",
        contentid: 418867315,
        inputtime: "2024-05-09",
        keyworDescribe: "关键描述:",
        progid: 0,
        progstr: "招标公告",
        searchType: 1,
        title: "中国路桥安哥拉2024RB-013AO导热油炉",
        typeid: 46,
        url: "https://www.qianlima.com/bid-418867315.html",
      },
      {
        areaName: "东山县",
        areaid: 198,
        content:
          "四航局河源和平省道项目<a style='color:red;'>搅拌站</a>设备租赁采购招标公告 项目编号：SCFA*** 发布时间：2024-05-08 14:00:00 公告 公告标题：四航局河源和平省道项目<a style='color:red;'>搅拌站</a>设备租赁采购招标公告 公告内容： 四航局河源和平省道项目<a style='color:red;'>搅拌站</a>设备租赁采购招标公告( <span style='color: #EA0A00'>搅拌站</span> 在正文中 )",
        contentid: 418670242,
        inputtime: "2024-05-08",
        keyworDescribe: "关键描述:",
        progid: 0,
        progstr: "招标公告",
        searchType: 1,
        title: "四航局河源和平省道项目<span style='color: #EA0A00'> 搅拌站</span>设备租赁采购招标公告",
        typeid: 61,
        url: "https://www.qianlima.com/bid-418670242.html",
      },
      {
        areaName: "福州市",
        areaid: 141,
        content:
          "流标公告 公告标题：和平省道二期项目<a style='color:red;'>搅拌站</a>设备租赁采购流标公告 公告内容： 我司于2024年 4月24日组织的和平省道二期项目<a style='color:red;'>搅拌站</a>设备租赁采购招标，现将具体情况公告如下： 招标编号：6GS-SDS339X-2024-04-01 流标原因：由于投标人数不足三家，不具备开标条件。 对流标项目我公司将重新组织采购。 附件列表 序号 附件名称 附件说明( <span style='color: #EA0A00'>搅拌站</span> 在正文中 )",
        contentid: 418609783,
        inputtime: "2024-05-08",
        keyworDescribe: "关键描述:",
        progid: 3,
        progstr: "中标结果",
        searchType: 1,
        title: "和平省道二期项目<span style='color: #EA0A00'> 搅拌站</span>设备租赁采购流标公告",
        typeid: 61,
        url: "https://www.qianlima.com/bid-418609783.html",
      },
      {
        areaName: "福州市",
        areaid: 141,
        content:
          "吨 2 车辆配件 车辆配件 4.00000000 套 3 滤芯 滤芯 5.00000000 套 4 水泥混凝土<a style='color:red;'>搅拌站</a>接触器 水泥混凝土<a style='color:red;'>搅拌站</a>接触器 202.00000000 个 5 凝固胶 凝固胶 2.00000000 桶 6 六角头螺栓 钢 4.6 粗牙 六角头螺栓 钢 4.6 粗牙( <span style='color: #EA0A00'>搅拌站</span> 在正文中 )",
        contentid: 418670256,
        inputtime: "2024-05-08",
        keyworDescribe: "关键描述:",
        progid: 0,
        progstr: "招标公告",
        searchType: 1,
        title: "宁古高速C1零星材料询价公告",
        typeid: 49,
        url: "https://www.qianlima.com/bid-418670256.html",
      },
      {
        areaName: "福州市",
        areaid: 141,
        content:
          "...据通知，及时安排车辆。 2、送货地址： 江苏省宿迁市宿城区中交二航局潍宿高铁3标项目部2#<a style='color:red;'>搅拌站</a>洋北街道，中顺路与港城路交叉路口附近 3、装车地址： 序号1-2装车地：江苏省泰兴市虹桥镇公殿村中交二航局常泰大桥 序号3-4装车地：江苏省南京市栖霞区中交二航局南京仙新路过江通道 序号5-6装车地：安徽省蚌埠市五河县双忠庙镇/申集镇中交第二航务工程局合肥建设有限...( <span style='color: #EA0A00'>搅拌站</span> 在正文中 )",
        contentid: 418486367,
        inputtime: "2024-05-07",
        keyworDescribe: "关键描述:",
        progid: 0,
        progstr: "招标公告",
        searchType: 1,
        title: "潍宿3标物流询价公告",
        typeid: 60,
        url: "https://www.qianlima.com/bid-418486367.html",
      },
      {
        areaName: "福州市",
        areaid: 141,
        content:
          "套 15 管卡 非金属 U形管卡DN150 1200.00000000 个 16 灯带 LED灯带 3000.00000000 米 17 混凝土<a style='color:red;'>搅拌站</a>电磁阀 电磁阀DN40 20.00000000 个 18 扁嘴钳 老虎钳 10.00000000 个 19 电动螺丝刀 螺口刀( <span style='color: #EA0A00'>搅拌站</span> 在正文中 )",
        contentid: 418299750,
        inputtime: "2024-05-07",
        keyworDescribe: "关键描述:",
        progid: 0,
        progstr: "招标公告",
        searchType: 1,
        title: "中交一公局集团建筑工程有限公司中房天津东丽雅郡项目四期项目经理部2024年5月临建物资采购",
        typeid: 49,
        url: "https://www.qianlima.com/bid-418299750.html",
      },
      {
        areaName: "福州市",
        areaid: 141,
        content:
          "...的质量保证等各种责任。 2.3交货要求 （1）交货地点：浙江省宁波市象山县贤庠镇中交二航局<a style='color:red;'>搅拌站</a>指定地点 。 （2）交货计划：具体交货时间、数量、规格型号按照项目部的发货要求。 （3）其它交货要求： 2.4计量方式 物资需求一览表中物资的计量方式为理论计量。 3.响应人须知 3.1包件划分 本次询价是/否划分包件。包件数量：个，包件划分详细情况见物资需求一览...( <span style='color: #EA0A00'>搅拌站</span> 在正文中 )",
        contentid: 418284897,
        inputtime: "2024-05-07",
        keyworDescribe: "关键描述:",
        progid: 0,
        progstr: "招标公告",
        searchType: 1,
        title: "宁象6标钢管桩加工询价公告",
        typeid: 49,
        url: "https://www.qianlima.com/bid-418284897.html",
      },
      {
        areaName: "福州市",
        areaid: 141,
        content:
          "...div 序号 设备物资名称 设备物资说明 数量 单位 1 混凝土<a style='color:red;'>搅拌站</a>电磁阀 物资名称：电磁阀 DG4V-5-2C-M-U-H6-20；采购要求：DANFOSS；SAP询价单：1000017754 1.00000000 件 2 混凝土<a style='color:red;'>搅拌站</a>电磁阀 物资名称：电磁阀 DG4V-3-52C-M-U-H7-60；采购要求：DANFOSS；SAP询价单：100001...( <span style='color: #EA0A00'>搅拌站</span> 在正文中 )",
        contentid: 418266988,
        inputtime: "2024-05-07",
        keyworDescribe: "关键描述:",
        progid: 0,
        progstr: "招标公告",
        searchType: 1,
        title: "17754电磁阀",
        typeid: 46,
        url: "https://www.qianlima.com/bid-418266988.html",
      },
      {
        areaName: "福州市",
        areaid: 141,
        content:
          "...混凝土<a style='color:red;'>搅拌站</a>设备报废询价公告 项目编号：SCFA*** 发布时间：2024-05-06 18:00:00 公告 公告标题：混凝土<a style='color:red;'>搅拌站</a>设备报废询价公告 公告内容： 中交二航局第四工程有限公司 设备报废处理询价公告 中交二航局第四工程有限公司因部分老旧设备处理需要，决定将以下设备进行报废处理。该项目已具备采购条件，现采用电子化方式进行公开询价采...( <span style='color: #EA0A00'>搅拌站</span> 在正文中 )",
        contentid: 418210184,
        inputtime: "2024-05-06",
        keyworDescribe: "关键描述:",
        progid: 0,
        progstr: "招标公告",
        searchType: 1,
        title: "混凝土<span style='color: #EA0A00'> 搅拌站</span>设备报废询价公告",
        typeid: 61,
        url: "https://www.qianlima.com/bid-418210184.html",
      },
      {
        areaName: "泉州市",
        areaid: 182,
        content:
          "...三一集团就三一泉州<a style='color:red;'>搅拌站</a>资质续签询比价在GSP平台在线招标厅进行电子采购 ，现公开邀请合格投标人进行网上电子投标。 一、项目内容 项目标号：XJ***1 项目标名：三一泉州<a style='color:red;'>搅拌站</a>资质续签询比价 二、投标人资格要求： 1、投标单位必须对投标的物料技术要求全部进行确认后才能参加。 2、投标单位不得给他人借、卖或挂靠资质，如有此种情况，经查证核实后...( <span style='color: #EA0A00'>搅拌站</span> 在正文中 )",
        contentid: 418116729,
        inputtime: "2024-05-06",
        keyworDescribe: "关键描述:",
        progid: 0,
        progstr: "招标公告",
        searchType: 1,
        title: "三一泉州<span style='color: #EA0A00'> 搅拌站</span>资质续签询比价询比价公告",
        typeid: 49,
        url: "https://www.qianlima.com/bid-418116729.html",
      },
      {
        areaName: "福州市",
        areaid: 141,
        content:
          "...00 套 30 液压阀组 阀组，020701545 6.00000000 套 31 混凝土<a style='color:red;'>搅拌站</a>油封 IDI油封 (90C)，021501007 150.00000000 个 32 钎头 通用规格 钎尾，028802266 50.00000000 台 33 紧定（衬）套 内衬套，028200010...( <span style='color: #EA0A00'>搅拌站</span> 在正文中 )",
        contentid: 418210193,
        inputtime: "2024-05-06",
        keyworDescribe: "关键描述:",
        progid: 0,
        progstr: "招标公告",
        searchType: 1,
        title: "新建川藏铁路雅安至林芝段CZXZZQ-5标段项目经理部一分部锚注一体机配件单一来源方式采购公告",
        typeid: 49,
        url: "https://www.qianlima.com/bid-418210193.html",
      },
      {
        areaName: "石狮市",
        areaid: 183,
        content:
          "设备物资名称 设备物资说明 数量 单位 水泥混凝土<a style='color:red;'>搅拌站</a> 25-40m3/h 废旧<a style='color:red;'>搅拌站</a>处理 1.0 套( <span style='color: #EA0A00'>搅拌站</span> 在正文中 )",
        contentid: 417913029,
        inputtime: "2024-05-02",
        keyworDescribe: "关键描述:",
        progid: 0,
        progstr: "招标公告",
        searchType: 1,
        title: "石湖废旧<span style='color: #EA0A00'> 搅拌站</span>处理方案",
        typeid: 68,
        url: "https://www.qianlima.com/bid-417913029.html",
      },
      {
        areaName: "石狮市",
        areaid: 183,
        content:
          "...福建泉州港石湖作业区5号和6号泊位工程项目废旧<a style='color:red;'>搅拌站</a>处理公告 项目编号：FA*** 发布时间：2024-05-02 09:00:00 公告 公告标题：福建泉州港石湖作业区5号和6号泊位工程项目废旧<a style='color:red;'>搅拌站</a>处理公告 公告内容： 1. 招标条件 本招标项目福建省泉州港石湖作业区5号和6号泊位工程项目（项目名称）招标人为 福建省泉州港石湖作业区5号和...( <span style='color: #EA0A00'>搅拌站</span> 在正文中 )",
        contentid: 417908190,
        inputtime: "2024-05-02",
        keyworDescribe: "关键描述:",
        progid: 0,
        progstr: "招标公告",
        searchType: 1,
        title: "福建泉州港石湖作业区5号和6号泊位工程项目废旧<span style='color: #EA0A00'> 搅拌站</span>处理公告",
        typeid: 46,
        url: "https://www.qianlima.com/bid-417908190.html",
      },
      {
        areaName: "福清市",
        areaid: 140,
        content:
          "...中核华辰金七门核电1、2号机组混凝土<a style='color:red;'>搅拌站</a>建设、运维、混凝土供应工程项目周转材料租赁服务采购任务采购结果公告 发布时间： 2024-04-30 16:29:58 中核华辰金七门核电1、2号机组混凝土<a style='color:red;'>搅拌站</a>建设、运维、混凝土供应工程项目周转材料租赁服务采购任务采购结果公告 中核华辰金七门核电1、2号机组混凝土<a style='color:red;'>搅拌站</a>建设、运维、混凝土供应工程项目周转材料租赁服务...( <span style='color: #EA0A00'>搅拌站</span> 在正文中 )",
        contentid: 417772131,
        inputtime: "2024-04-30",
        keyworDescribe: "关键描述:",
        progid: 3,
        progstr: "中标结果",
        searchType: 1,
        title:
          "中核华辰金七门核电1、2号机组混凝土<span style='color: #EA0A00'> 搅拌站</span>建设、运维、混凝土供应工程项目周转材料租赁服务采购任务采购结果公告",
        typeid: 61,
        url: "https://www.qianlima.com/bid-417772131.html",
      },
      {
        areaName: "霞浦县",
        areaid: 171,
        content:
          "...现场<a style='color:red;'>搅拌站</a>B区3#4#生产线设备拆除项目服务询价采购公告 1.采购项目简介 1.1采购项目概况：现场<a style='color:red;'>搅拌站</a>B区3#4#生产线设备拆除项目服务，具体见技术规格书 。 1.2采购范围：具体内容详见《现场<a style='color:red;'>搅拌站</a>B区3#4#生产线设备拆除项目服务技术规格书》 1.3服务期限（到货时间）：合同签订之日起至2024年06月30日止（具体日期由双方根据实际情况协商确定）。...( <span style='color: #EA0A00'>搅拌站</span> 在正文中 )",
        contentid: 417655835,
        inputtime: "2024-04-30",
        keyworDescribe: "关键描述:",
        progid: 0,
        progstr: "招标公告",
        searchType: 1,
        title: "现场<span style='color: #EA0A00'> 搅拌站</span>B区3#4#生产线设备拆除项目服务采购公告",
        typeid: 46,
        url: "https://www.qianlima.com/bid-417655835.html",
      },
      {
        areaName: "福州市",
        areaid: 141,
        content:
          "<a style='color:red;'>搅拌站</a>配件采购 项目编号：FA*** 发布时间：2024-04-29 18:00:00 公告 公告标题：<a style='color:red;'>搅拌站</a>配件采购 公告内容： 北海铁山港西港区北暮作业区9号、10号泊位水工工程<a style='color:red;'>搅拌站</a>维修更换配件1批，具体规格型号按报价单和采购计划单为准 附件列表 序号 附件名称 附件说明 1( <span style='color: #EA0A00'>搅拌站</span> 在正文中 )",
        contentid: 417522272,
        inputtime: "2024-04-29",
        keyworDescribe: "关键描述:",
        progid: 0,
        progstr: "招标公告",
        searchType: 1,
        title: "<span style='color: #EA0A00'> 搅拌站</span>配件采购",
        typeid: 46,
        url: "https://www.qianlima.com/bid-417522272.html",
      },
      {
        areaName: "福州市",
        areaid: 141,
        content:
          "...中核华辰金七门核电1、2号机组混凝土<a style='color:red;'>搅拌站</a>建设、运维、混凝土供应工程项目地材采购任务采购结果公告 发布时间： 2024-04-29 09:40:38 中核华辰金七门核电1、2号机组混凝土<a style='color:red;'>搅拌站</a>建设、运维、混凝土供应工程项目地材采购任务采购结果公告 中核华辰金七门核电1、2号机组混凝土<a style='color:red;'>搅拌站</a>建设、运维、混凝土供应工程项目地材采购任务采购项目经评审采购结果已确定...( <span style='color: #EA0A00'>搅拌站</span> 在正文中 )",
        contentid: 417305911,
        inputtime: "2024-04-29",
        keyworDescribe: "关键描述:",
        progid: 3,
        progstr: "中标结果",
        searchType: 1,
        title:
          "中核华辰金七门核电1、2号机组混凝土<span style='color: #EA0A00'> 搅拌站</span>建设、运维、混凝土供应工程项目地材采购任务采购结果公告",
        typeid: 48,
        url: "https://www.qianlima.com/bid-417305911.html",
      },
      {
        areaName: "福州市",
        areaid: 141,
        content:
          "...中核华辰金七门核电1、2号机组混凝土<a style='color:red;'>搅拌站</a>建设、运维、混凝土供应工程项目商品混凝土采购任务采购结果公告 发布时间： 2024-04-29 09:40:20 中核华辰金七门核电1、2号机组混凝土<a style='color:red;'>搅拌站</a>建设、运维、混凝土供应工程项目商品混凝土采购任务采购结果公告 中核华辰金七门核电1、2号机组混凝土<a style='color:red;'>搅拌站</a>建设、运维、混凝土供应工程项目商品混凝土采购任务采购项目经...( <span style='color: #EA0A00'>搅拌站</span> 在正文中 )",
        contentid: 417305224,
        inputtime: "2024-04-29",
        keyworDescribe: "关键描述:",
        progid: 3,
        progstr: "中标结果",
        searchType: 1,
        title:
          "中核华辰金七门核电1、2号机组混凝土<span style='color: #EA0A00'> 搅拌站</span>建设、运维、混凝土供应工程项目商品混凝土采购任务采购结果公告",
        typeid: 61,
        url: "https://www.qianlima.com/bid-417305224.html",
      },
    ],
    cids: "419924647,419897482,419854612",
    jumpUrl: "https://wap.qianlima.com/gjxx/71/index_3.html",
    keyword: "搅拌站",
    title: "福建搅拌站招标采购",
    total: 1045,
    version: "v1.1.5-gjxx",
    wId: 71,
    relationList : [{"title":"安防监控","url":"/gjxx/199578_2703_4"}],
    rmcszb:[{"title":"安防监控","url":"/gjxx/199578_2703_4"}]
  },
};
export default STATIC_DATA;
